import { WordVoiceCommandIds, SelectionWhich, SelectionType, } from "@augloop-types/voice";
var unsupportedCommands = new Set([
    WordVoiceCommandIds.Paste,
    WordVoiceCommandIds.Redo,
]);
// OOUI often gets blocked updating types-voice, you can
// put your commandId here rather than waiting for the updated package
var ExperimentalCommandIds;
(function (ExperimentalCommandIds) {
    ExperimentalCommandIds["ZoomIn"] = "Word.View.ZoomIn";
    ExperimentalCommandIds["ZoomOut"] = "Word.View.ZoomOut";
    ExperimentalCommandIds["ShowOutline"] = "Word.View.ShowOutline";
    ExperimentalCommandIds["ScrollUp"] = "Word.View.ScrollUp";
    ExperimentalCommandIds["ScrollDown"] = "Word.View.ScrollDown";
    ExperimentalCommandIds["ReadBack"] = "Word.Editing.ReadBack";
    ExperimentalCommandIds["PageBreak"] = "Word.Editing.PageBreak";
})(ExperimentalCommandIds || (ExperimentalCommandIds = {}));
export var ExperimentalCommandSetNames;
(function (ExperimentalCommandSetNames) {
    ExperimentalCommandSetNames["ReadBack"] = "ReadBack";
    ExperimentalCommandSetNames["ChangeViews"] = "ChangeViews";
    ExperimentalCommandSetNames["PageBreak"] = "PageBreak";
    ExperimentalCommandSetNames["Correction"] = "Correction";
})(ExperimentalCommandSetNames || (ExperimentalCommandSetNames = {}));
var experimentalCommandSets = new Map([
    // Hack: ADO:4899550 - Switch from hardcoded string to WordVoiceCommandIds once we are able to update the types-voice pkg version.
    [
        ExperimentalCommandSetNames.ReadBack,
        new Set([ExperimentalCommandIds.ReadBack]),
    ],
    [
        ExperimentalCommandSetNames.ChangeViews,
        new Set([
            ExperimentalCommandIds.ZoomIn,
            ExperimentalCommandIds.ZoomOut,
            ExperimentalCommandIds.ShowOutline,
            ExperimentalCommandIds.ScrollDown,
            ExperimentalCommandIds.ScrollUp,
        ]),
    ],
    [
        ExperimentalCommandSetNames.PageBreak,
        new Set([ExperimentalCommandIds.PageBreak]),
    ],
    [
        ExperimentalCommandSetNames.Correction,
        new Set([
            WordVoiceCommandIds.Correction,
            WordVoiceCommandIds.CorrectionOption,
        ]),
    ],
]);
// Temporary change for V1
var commandsWithSelection = new Set([
    WordVoiceCommandIds.Bold,
    WordVoiceCommandIds.Italics,
    WordVoiceCommandIds.Underline,
    WordVoiceCommandIds.Highlight,
    WordVoiceCommandIds.Select,
    WordVoiceCommandIds.Superscript,
    WordVoiceCommandIds.Subscript,
    WordVoiceCommandIds.StrikeThrough,
    WordVoiceCommandIds.RemoveBold,
    WordVoiceCommandIds.RemoveItalics,
    WordVoiceCommandIds.RemoveUnderline,
    WordVoiceCommandIds.RemoveHighlight,
    WordVoiceCommandIds.RemoveSuperscript,
    WordVoiceCommandIds.RemoveSubscript,
    WordVoiceCommandIds.RemoveStrikeThrough,
    WordVoiceCommandIds.Delete,
    WordVoiceCommandIds.Quote,
    WordVoiceCommandIds.Navigation,
    WordVoiceCommandIds.AllCaps,
    WordVoiceCommandIds.LowerCase,
    WordVoiceCommandIds.SentenceCase,
]);
var enumKeysOfExperimentalVoiceCommandIds = Object.keys(ExperimentalCommandIds);
var enumKeysOfWordVoiceCommandIds = Object.keys(WordVoiceCommandIds);
function getExperimentalCommandSetFromEnabledCommandSetNames(enabledExperimentalCommandsSetNames) {
    var enabledExperimentalCommands = new Set();
    enabledExperimentalCommandsSetNames.forEach(function (commandSetName) {
        var entry = experimentalCommandSets.get(commandSetName);
        if (entry != null) {
            entry.forEach(function (commandId) {
                enabledExperimentalCommands.add(commandId);
            });
        }
    });
    return enabledExperimentalCommands;
}
export var getValidCommandSet = function (enabledExperimentalCommandsSetNames) {
    var validCommandSet = new Set();
    var enabledExperimentalCommands = getExperimentalCommandSetFromEnabledCommandSetNames(enabledExperimentalCommandsSetNames);
    var allExperimentalCommands = getExperimentalCommandSetFromEnabledCommandSetNames(Object.keys(ExperimentalCommandSetNames));
    for (var _i = 0, enumKeysOfWordVoiceCommandIds_1 = enumKeysOfWordVoiceCommandIds; _i < enumKeysOfWordVoiceCommandIds_1.length; _i++) {
        var key = enumKeysOfWordVoiceCommandIds_1[_i];
        // If the command is experimental and is not enabled or it's unsupported, don't process it.
        if ((allExperimentalCommands.has(WordVoiceCommandIds[key]) &&
            !enabledExperimentalCommands.has(WordVoiceCommandIds[key])) ||
            unsupportedCommands.has(WordVoiceCommandIds[key])) {
            continue;
        }
        validCommandSet.add(WordVoiceCommandIds[key]);
    }
    for (var _a = 0, enumKeysOfExperimentalVoiceCommandIds_1 = enumKeysOfExperimentalVoiceCommandIds; _a < enumKeysOfExperimentalVoiceCommandIds_1.length; _a++) {
        var key = enumKeysOfExperimentalVoiceCommandIds_1[_a];
        if (enabledExperimentalCommands.has(ExperimentalCommandIds[key]) &&
            allExperimentalCommands.has(ExperimentalCommandIds[key])) {
            validCommandSet.add(ExperimentalCommandIds[key]);
        }
    }
    return validCommandSet;
};
/** Returns true if this command is valid */
export var hasValidCommandValues = function (command) {
    if (commandsWithSelection.has(command.commandId)) {
        return !(command.selection &&
            isInvalidSelection(command.selection, command.commandId));
    }
    return true;
};
/**
 * Commands that need the new CommandSet abilities on the voice commanding workflow in order to work
 */
export var needsCommandSets = function (commandId) {
    return (commandId === WordVoiceCommandIds.Correction ||
        commandId === WordVoiceCommandIds.CorrectionOption);
};
/** Returns true if selection is invalid. We do don't support Next in selection (unless FormatNext flight is On) */
var isInvalidSelection = function (selection, commandId) {
    // Only support "Go\Move to NEXT\PREVIOUS\END paragraph\word\bullet\sentence"
    if (commandId === WordVoiceCommandIds.Navigation) {
        // Don't support "Go\Move to BEGINNING of paragraph\word\bullet\sentence"
        if (!(selection.which === SelectionWhich.Next ||
            selection.which === SelectionWhich.Previous ||
            selection.which === SelectionWhich.End)) {
            return true;
        }
        // Currently support only "Go\Move to Next\Previous paragraph\word\bullet\sentence"
        if (!(selection.type === SelectionType.Word ||
            selection.type === SelectionType.Bullet ||
            selection.type === SelectionType.Sentence ||
            selection.type === SelectionType.Paragraph)) {
            return true;
        }
        return false;
    }
    return false;
};
/** Takes command and alters and returns the same. */
export var alterCommandValue = function (command) {
    var _a;
    // If command is InsertComment, then keep only command text for floatie, and remove actual comment
    if (command.commandId === WordVoiceCommandIds.InsertComment) {
        command.sourceText = ((_a = command === null || command === void 0 ? void 0 : command.comment) === null || _a === void 0 ? void 0 : _a.commentCommand) || command.sourceText;
    }
    return command;
};
//# sourceMappingURL=validCommandUtil.js.map